import { render } from "./WalletConvert.vue?vue&type=template&id=88b72a68&scoped=true"
import script from "./WalletConvert.vue?vue&type=script&lang=js"
export * from "./WalletConvert.vue?vue&type=script&lang=js"

import "./WalletConvert.vue?vue&type=style&index=0&id=88b72a68&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b72a68"]])

export default __exports__